import { useEntities } from 'app/agriculture/queries/entities/useEntities';

export function useTanks() {
    return useEntities('Tank');
}
